import { CircularProgress, Flex, HStack, Text } from '@chakra-ui/react'
import { ScreenContext, useAuth } from '@hb/react'
import { PageContainer, PatientDocuments, SignInToView } from '@hb/react-web'
import { useContext } from 'react'

export const MyDocuments = () => {
  const { contentWidth } = useContext(ScreenContext)
  const { authUser, loading } = useAuth()
  if (!authUser) {
    return <SignInToView message="Sign in to view your documents" />
  }
  const body = loading ? (
    <HStack p={2} bg="white" borderRadius={6} boxShadow="md">
      <CircularProgress isIndeterminate />
      <Text> Loading your account... </Text>
    </HStack>
  ) : (
    <Flex
      flex={1}
      p={2}
      w="100%"
      overflowY="auto"
      width={contentWidth}
      position="relative"
      direction="column"
      align="center">
      <PatientDocuments patientId={authUser.uid} />
    </Flex>
  )

  return <PageContainer>{body}</PageContainer>
}
